// @flow
import React from 'react';

import { getProvidedByTooltipTextGivenLabelText } from '../../common-utils/utils';
import {
  ADMIN_IMPORTED_LABEL_TEXT,
  SYSTEM_GENERATED_LABEL_TEXT,
  ADMIN_LABEL_TEXT,
  NON_ADMIN_LABEL_TEXT,
} from '../../constants';
import { LabelWithPopup } from '../presentational/LabelWithPopup';

const getLabelText = (isImported, isSystemGenerated, isAddedByAdmin) => {
  if (isImported) {
    return ADMIN_IMPORTED_LABEL_TEXT;
  }
  if (isSystemGenerated) {
    return SYSTEM_GENERATED_LABEL_TEXT;
  }
  if (isAddedByAdmin) {
    return ADMIN_LABEL_TEXT;
  }
  return NON_ADMIN_LABEL_TEXT;
};

export const SystemAdminNonAdminStatusLabel = ({
  isImported = false,
  isSystemGenerated = false,
  isAddedByAdmin = false,
  ribbon = true,
}) => {
  const labelText = getLabelText(isImported, isSystemGenerated, isAddedByAdmin);
  const tooltipText = getProvidedByTooltipTextGivenLabelText(labelText);
  // Use Label directly (not StyledLabel) to preserve teal color in dark mode
  // StyledLabel overrides color prop with theme colors, breaking the teal appearance
  return (
    <LabelWithPopup
      labelColor="teal"
      labelRibbon={ribbon}
      labelStyle={{ paddingLeft: '14.4px' }}
      labelText={labelText}
      popupPosition="top right"
      popupSize="tiny"
      popupTooltipText={tooltipText}
    />
  );
};
